import MenuManager from './MenuManager.vue';

export const menuManagerRoutes = [
  { path: 'menu-manager', component: MenuManager, name: 'menu-manager' }
];
